import { TextField } from "@mui/material";
import styled from "styled-components"
import { topBarSize, leftBarSize } from "../../../Components/NavBar/styles";
import PasswordInput from "../../Patients/Create/PasswordInput";
import UploadFileIcon from '@mui/icons-material/UploadFile';

export const Container = styled.div`  
    position: absolute;
    top: calc(${topBarSize});
    left: calc(${leftBarSize});

    width: calc(100% - calc(${leftBarSize} + 1.5rem)) !important;
    height: calc(100% - calc(${topBarSize} + 2rem)) !important;

    padding-top: 1rem;
    padding-left: 1rem;


    z-index: 1;
`;

export const Title = styled.p`
    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: rgba(55, 73, 87, 0.7);
    font-size: 2rem;

    z-index: 2;

    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;

    -ms-flex-align: center;
    -webkit-align-items: center;
`;

export const Button = styled.button`
    position: absolute;
    right: 0%;

    height: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;

    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: #2E933C;

    background: none;
    border: 2px solid #2E933C;
    border-radius: 20px;

    cursor: pointer;

    &:hover{
        background: rgba(55, 73, 87, 0.1);
        transition-duration: 0.1s;
    }

    &:active{
        background: rgba(55, 73, 87, 0.2);
        transition-duration: 0.1s;
    }

    z-index: 3;
`;

export const Content = styled.div`
    
    width: 95%;
    height: 80%;

    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    border-radius: 10px;
    padding: 5px !important;
    border: 1px solid ${(props) => props.theme.border};
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
`;

export const ContentTitle = styled(Title)`
    color: rgba(55, 73, 87, 1.0);
    font-size: 1.6rem;
    padding-left: 1rem;
    text-transform: none;
    margin-bottom: 1rem;
`;

export const ContentBody = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
    height: 100%;
    position: relative;
`;

export const ContentBodyLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-right: 1rem;
`;

export const ContentBodyRight = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 1rem;
`;

export const InputLabel = styled.span`
    color: gray;
    font-size: 0.875rem;
    font-weight: 500;
    display: block;
    margin-bottom: 0.25rem;
`;

export const ContentInput = styled(TextField)`
    margin-top: 0 !important;

    & .MuiFormLabel-root {
        color: gray;
        font-size: 0.875rem;
        font-weight: 500;

        &.Mui-focused {
            color: gray;
        }
    }

    & .MuiInput-underline::after {
        border-bottom-color: #2E933C;
    }
`;

export const ContentInputPassword = styled(PasswordInput)`
`;

export const ContentInputProfilePhotoIcon = styled(UploadFileIcon)`
    position: absolute;

    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%) scale(4);

    color: rgba(255, 255, 255, 0.5);

    opacity: 1;

`;

export const ContentInputProfilePhoto = styled.div`
    border: 1px solid ${(props) => props.theme.border};
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);

    width: 20rem;
    height: 20rem;

    position: relative;
    border-radius: 20px;

    opacity: 0.7;

    z-index: 3;

    &:hover{
        opacity: 1;
        cursor: pointer;
        transition: all 0.2s;
    }

    &:active{
        opacity: 0.5;
    }

    & img{
        width: 100%;
        height: 100%;
        border-radius: 20px;
    }
`;

export const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 0.5rem;
`;

export const FieldLabel = styled(InputLabel)`
    margin-bottom: 0.5rem;
`;

export const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
`;

export const Tag = styled.div<{ color?: string }>`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 0.8rem;
    background-color: ${(props) => props.color || '#2E933C'};
    color: white;
    border-radius: 16px;
    font-size: 0.875rem;
    font-weight: 500;
    white-space: nowrap;
`;

export const RemoveButton = styled.button`
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 1.2rem;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.2rem;
    height: 1.2rem;

    &:hover {
        opacity: 0.8;
    }
`;

export const FolderFieldRowFull = styled.div`
    display: flex;
    gap: 0.5rem;
    width: 100%;
`;

export const InputFieldSimple = styled.input`
    padding: 0.5rem;
    border: 1px solid ${(props) => props.theme.border || '#ddd'};
    border-radius: 4px;
    font-size: 0.875rem;
    font-family: 'Roboto';

    &:focus {
        outline: none;
        border-color: #2E933C;
        box-shadow: 0 0 0 2px rgba(46, 147, 60, 0.1);
    }
`;